const LOCAL_API_BASE_URL = 'http://localhost:5070';

function isLocalHostname(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function getApiBaseUrl(): string {
  if (typeof window === 'undefined') {
    // SSR/build-time contexts should not force a browser origin.
    return '';
  }

  // Local dev hits the .NET API directly; deployed builds use same-origin (/api/* proxy).
  return isLocalHostname(window.location.hostname) ? LOCAL_API_BASE_URL : window.location.origin;
}

export const API_BASE_URL = getApiBaseUrl();
